/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { updateBoxProductDeadlines } from '../fn/deadline-controller/update-box-product-deadlines';
import { UpdateBoxProductDeadlines$Params } from '../fn/deadline-controller/update-box-product-deadlines';

@Injectable({ providedIn: 'root' })
export class DeadlineControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateBoxProductDeadlines()` */
  static readonly UpdateBoxProductDeadlinesPath = '/box-products/deadlines';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBoxProductDeadlines()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBoxProductDeadlines$Response(params?: UpdateBoxProductDeadlines$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBoxProductDeadlines(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBoxProductDeadlines$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateBoxProductDeadlines(params?: UpdateBoxProductDeadlines$Params, context?: HttpContext): Observable<void> {
    return this.updateBoxProductDeadlines$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
